import { render } from "./people.vue?vue&type=template&id=dbade278&scoped=true"
import script from "./people.vue?vue&type=script&lang=js"
export * from "./people.vue?vue&type=script&lang=js"

import "./people.vue?vue&type=style&index=0&id=dbade278&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dbade278"

export default script